// Configurazione centralizzata per tutte le esperienze AR
// Questo file contiene i parametri per le 16 esperienze AR che usano image targets

export const arExperiencesConfig = {
  // Esperienze esistenti

}

// Funzione helper per creare esperienze AR
export const createARExperience = (config) => {
  return {
    id: config.id,
    title: config.title,
    text: config.description,
    img: config.img,
    config: {
      experienceType: 'ar',
      modelType: 'genericAR',
      title: config.title,
      description: config.description,
      customParams: {
        targetName: config.targetName,
        videoName: config.videoName,
        videoPath: config.videoPath,
        cameraPosition: config.cameraPosition,
        lightIntensity: config.lightIntensity,
        imagePath: config.imagePath,
        imageScale: config.imageScale,
        thumb: config.thumb,  // Add thumb parameter
        height: config.height,  // Add height parameter
        width: config.width,  // Add width parameter
        arType: 'video-fade'
      }
    }
  }
}

// Funzione per generare tutte le esperienze AR dalla configurazione
export const generateAllARExperiences = () => {
  const experiences = []
  
  // Aggiungi esperienze esistenti
  Object.keys(arExperiencesConfig).forEach(key => {
    if (key !== 'template') {
      experiences.push(createARExperience(arExperiencesConfig[key]))
    }
  })
  
  return experiences
}

// Funzione per aggiungere una nuova esperienza AR
export const addARExperience = (newExperience) => {
  arExperiencesConfig[newExperience.id] = newExperience
  console.log(`✅ Nuova esperienza AR aggiunta: ${newExperience.id}`)
  return newExperience
}

// Funzione per ottenere la configurazione di un'esperienza specifica
export const getARExperienceConfig = (experienceId) => {
  return arExperiencesConfig[experienceId] || null
}

// Funzione per aggiornare un'esperienza esistente
export const updateARExperience = (experienceId, updates) => {
  if (arExperiencesConfig[experienceId]) {
    arExperiencesConfig[experienceId] = { ...arExperiencesConfig[experienceId], ...updates }
    console.log(`✅ Esperienza AR aggiornata: ${experienceId}`)
    return arExperiencesConfig[experienceId]
  }
  return null
}

// Funzione per rimuovere un'esperienza
export const removeARExperience = (experienceId) => {
  if (arExperiencesConfig[experienceId]) {
    delete arExperiencesConfig[experienceId]
    console.log(`🗑️ Esperienza AR rimossa: ${experienceId}`)
    return true
  }
  return false
}

// Funzione per validare la configurazione di un'esperienza
export const validateARExperience = (config) => {
  const required = ['id', 'targetName', 'videoName', 'title', 'description', 'img', 'videoPath']
  const optional = ['imagePath', 'imageScale', 'cameraPosition', 'lightIntensity', 'thumb', 'height', 'width']
  const missing = required.filter(field => !config[field])
  
  if (missing.length > 0) {
    console.error(`❌ Configurazione esperienza AR incompleta. Campi mancanti: ${missing.join(', ')}`)
    return false
  }
  
  // Valida parametri opzionali se presenti
  if (config.imagePath && !config.imagePath.startsWith('http')) {
    console.warn(`⚠️ imagePath dovrebbe essere un URL completo: ${config.imagePath}`)
  }
  
  if (config.imageScale && !/^\d+(\.\d+)? \d+(\.\d+)? \d+(\.\d+)?$/.test(config.imageScale)) {
    console.warn(`⚠️ imageScale dovrebbe essere nel formato "x y z": ${config.imageScale}`)
  }

  if (config.thumb && !config.thumb.startsWith('http')) {
    console.warn(`⚠️ thumb dovrebbe essere un URL completo: ${config.thumb}`)
  }

  if (config.height && !/^\d+(\.\d+)?$/.test(config.height)) {
    console.warn(`⚠️ height dovrebbe essere un numero: ${config.height}`)
  }

  if (config.width && !/^\d+(\.\d+)?$/.test(config.width)) {
    console.warn(`⚠️ width dovrebbe essere un numero: ${config.width}`)
  }
  
  return true
}

// Esporta la configurazione completa
export default arExperiencesConfig 